<p>manualorder works!</p>
